import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { DataLogger } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  deviceId: string;
  options?: Omit<
    UseQueryOptions<unknown, Error, DataLogger>,
    'queryKey' | 'queryFn'
  >;
}

export const useDataLoggerRequest = ({ deviceId, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, DataLogger>(
    [Entities.DataLoggers, deviceId],
    async () => {
      const { data } = await api.v1AdminDataLoggersDeviceIdGet(deviceId)
      return data
    },
    { ...options },
  )
}
